import Vue from 'vue'
import App from './App.vue'
import store from './store/store'
import router from './router'

Vue.config.productionTip = false

import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'
Vue.use(VueMaterial)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
